import React from 'react';
import { useTranslation } from 'react-i18next';
import Login from './Login.js';

function Welcome() {
	const { t } = useTranslation();

	return (
		<div className="Welcome">
			<section>
				<Login />
			</section>
			<footer>
				<ul className="FooterMenu">
					<li><span>Dottie &copy; {new Date().getFullYear()}</span></li>
					<li><a href="/Privacy-Policy">{t('PrivacyLegal', 'Privacy & Legal')}</a></li>
					<li><a href="/Help">{t('Help', 'Help')}</a></li>
				</ul>
			</footer>
		</div>
	);
}

export default Welcome;
